var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InnovationBalance',{ref:"innovationBalanceRef"}),_c('TotalQuoteItems',{attrs:{"quote-distribution":_vm.quoteDistribution}}),_c('AcceptOrRejectAskedQuote',{on:{"refetchTables":_vm.refetchTables}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }